import React, { Component } from 'react';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import Editbox from '../../../Part_Sample/Editbox';
import qrcode from '../../../../Images/Daikin_Images/image/QR.png';
import ipcam from '../../../../Images/Daikin_Images/image/Ipcam.png';
import { loginCamera } from './js/addCamera';
import { loginNVR } from './js/loginNVR';

export default class DLinkAddEditCamera extends Component {
	constructor(props) {
		super(props);

		let username = '';
		let password = '';
		let serialNo = '';
		let device_name = '';
		let device_type = '';
		let device_type_no = -1;

		let controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
		this.controller_mac_addr = controller_info.mac_addr;
		this.controller_username = controller_info.username;

		this.index = -1;

		let from = this.props.param.from; //indicates if is add/edit function
		if (from == 'DLinkEditCamera') {
			this.index = this.props.param.index;
			let dlinkcameras = JSON.parse(window.localStorage.getItem('dlinkcameras'));
			let cameras = dlinkcameras[this.controller_mac_addr][this.controller_username].cameras;
			username = cameras[this.index].username;
			password = cameras[this.index].password;
			serialNo = cameras[this.index].serialNo;
			device_name = cameras[this.index].deviceName;
			device_type_no = cameras[this.index].deviceType;
			switch (device_type_no) {
				case 1:
					device_type = this.props.receiver.getString('dlink_networkcameraequipment');
					break;
				case 2:
					device_type = this.props.receiver.getString('dlink_recorderequipment');
					break;
				case 3:
					device_type = this.props.receiver.getString('dlink_serverequipment');
					break;
				case 4:
					device_type = this.props.receiver.getString('dlink_speeddome');
					break;
				case 10:
				case 5:
					device_type = this.props.receiver.getString('dlink_nvr');
					break;
				case 6:
					device_type = this.props.receiver.getString('dlink_onvif');
					break;
				case 7:
					device_type = this.props.receiver.getString('dlink_decoder');
					break;
				default:
					device_type = this.props.receiver.getString('dlink_lprecognitioncamera');
					break;
			}
		}

		this.from = from;
		this.username = username;
		this.password = password;
		this.serialNo = serialNo;
		this.device_name = device_name;
		this.device_type = device_type;
		this.device_type_no = device_type_no;
		this.state = {
			username: username,
			password: password,
			serialNo: serialNo,
			device_name: device_name,
			device_type: device_type,
			temp_devices: [],
			count: 0
		}

		//If device is currently in "edit " mode and it is an NVR
		if (this.from == 'DLinkEditCamera' && (this.device_type_no == 5 || this.device_type_no == 10)) {
			this.loginToNVR(); //retrieve all the cameras connected to NVR
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('DLinkCameras');
	}

	handleChangeUsername = (val) => {
		this.setState({ username: val })
	}

	handleChangePassword = (val) => {
		this.setState({ password: val })
	}

	handleChangeDeviceName = (val) => {
		const message = val.slice(0, 20);
		this.setState({ device_name: message })
	}

	handleChangeSerialNo = (val) => {
		this.setState({ serialNo: val })
	}

	//Add Camera
	handleRegister = () => {
		//Form validation
		if (this.state.username == '' || this.state.password == '' || this.state.serialNo == '' || this.state.device_name == '') {
			window.app.showToast(this.props.receiver.getString('ipcam_fillblanks'), 3000);
			return;
		}

		// Tommy - 13/04/2021
		let dlinkcameras = JSON.parse(window.localStorage.getItem('dlinkcameras') || {});
		let cameras = dlinkcameras[this.controller_mac_addr][this.controller_username].cameras;

		//If user just wants to change the device name
		if (this.from == 'DLinkEditCamera') {
			if (this.state.username == this.username &&
				this.state.password == this.password &&
				this.state.serialNo == this.serialNo) {
				cameras[this.index].deviceName = this.state.device_name;
				dlinkcameras[this.controller_mac_addr][this.controller_username].cameras = cameras;
				window.localStorage.setItem('dlinkcameras', JSON.stringify(dlinkcameras)); //save to local storage
				this.handlePrevious();
				return;
			}
		}

		//if user is trying to add a new device
		if (this.from == 'DLinkAddCamera') {
			//Check if the camera is already added into localStorage
			for (let i = 0; i < cameras.length; i++) {
				if (cameras[i].deviceType == 5 || cameras[i].deviceType == 10) { //If device is an nvr
					if (cameras[i].serialNo == this.state.serialNo) {
						window.app.showToast(this.props.receiver.getString('dlink_youaddedthisdevice'), 3000);
						return;
					} else {
						let nvr_cameras = cameras[i].cameras;
						for (let j = 0; j < cameras.length; j++) {
							if (nvr_cameras[j].serialNo == this.state.serialNo) {
								window.app.showToast(this.props.receiver.getString('dlink_youaddedthisdevice'), 3000);
								return;
							}
						}
					}
				} else {
					if (cameras[i].serialNo == this.state.serialNo) {
						window.app.showToast(this.props.receiver.getString('dlink_youaddedthisdevice'), 3000);
						return;
					}
				}
			}
		}

		window.app.showLoading();
		loginCamera(this.loginSuccess, this.loginFailed, this.state.username, this.state.password, this.state.serialNo);
	}

	loginSuccess = (result) => {
		//If device is a NVR, retrieve connected devices from the NVR
		if (result == 5 || result == 10) {
			this.device_type_no = result;
			loginNVR(this.loginNVRSuccess, this.loginNVRFailed, this.state.username, this.state.password, this.state.serialNo, result);
		} else {

			// Tommy - 13/04/2021
			let dlinkcameras = JSON.parse(window.localStorage.getItem('dlinkcameras'));
			let cameras = dlinkcameras[this.controller_mac_addr][this.controller_username].cameras;
			if (cameras == null) cameras = [];

			if (this.from == 'DLinkAddCamera') { //if user is adding a new device
				cameras.push({ serialNo: this.state.serialNo, username: this.state.username, password: this.state.password, deviceName: this.state.device_name, deviceType: result, cameras: [], channelNumber: 1 });
			} else { //if user is saving device details
				cameras[this.index].username = this.state.username;
				cameras[this.index].password = this.state.password;
			}

			dlinkcameras[this.controller_mac_addr][this.controller_username].cameras = cameras;
			window.localStorage.setItem('dlinkcameras', JSON.stringify(dlinkcameras));
			window.app.hideLoading();
			this.handlePrevious();
		}
	}

	loginFailed = () => {
		window.app.hideLoading();
		if (this.state.count < 2) {
			window.app.showLoading();
			this.setState({ count: this.state.count + 1 })
			loginCamera(this.loginSuccess, this.loginFailed, this.state.username, this.state.password, this.state.serialNo);
		} else {
			window.app.showToast(this.props.receiver.getString('ipcam_deviceaddedfailed'), 3000);
		}
	}

	//Login NVR with username, password, serial number
	loginToNVR = () => {
		window.app.showLoading();
		loginNVR(this.loginNVRSuccess, this.loginNVRFailed, this.username, this.password, this.serialNo, this.device_type_no);
	}

	//result = list of nvr channel names
	loginNVRSuccess = (result) => {
		let array = result.split(',');
		let temp_devices = []; //list of nvr channel names
		for (let i in array) {
			if (array[i] == '') {
				break;
			} else {
				let temp_device = {};
				// Channel Id
				temp_device.channel_id = array[i].substring(array[i].indexOf('channel_id:') + 11, array[i].indexOf('\n'));
				if (temp_device.channel_id != '') array[i] = array[i].substring(array[i].indexOf('\n') + 1, array[i].length);
				// Camera Name
				temp_device.camera_name = array[i].substring(array[i].indexOf('camera_name:') + 12, array[i].indexOf('\n'));
				// Camera Type - for now assume is ip camera
				temp_device.deviceType = 1;

				// Check if the channel has any device connected to it
				// If yes add to the list of devices
				if (temp_device.camera_name.length > 0) {
					temp_devices.push({ serialNo: this.state.serialNo, username: this.state.username, password: this.state.password, deviceName: temp_device.camera_name, deviceType: temp_device.deviceType, cameras: [], channelNumber: temp_device.channel_id });
					this.state.temp_devices.push(temp_device);
				}
			}
		}

		window.app.hideLoading();
		let dlinkcameras = JSON.parse(window.localStorage.getItem('dlinkcameras'));
		let cameras = dlinkcameras[this.controller_mac_addr][this.controller_username].cameras;

		//if currently in 'add' mode, add new device
		if (this.from == 'DLinkAddCamera') {
			// Add the new camera into existing list of cameras
			cameras.push({ serialNo: this.state.serialNo, username: this.state.username, password: this.state.password, deviceName: this.state.device_name, deviceType: this.device_type_no, cameras: temp_devices, channelNumber: 1 });
			dlinkcameras[this.controller_mac_addr][this.controller_username].cameras = cameras;
			window.localStorage.setItem('dlinkcameras', JSON.stringify(dlinkcameras));
			this.handlePrevious();
		} else { //if currently in 'edit' mode, update the cameras
			cameras[this.index].cameras = [];
			cameras[this.index].cameras = temp_devices;
			dlinkcameras[this.controller_mac_addr][this.controller_username].cameras = cameras
			window.localStorage.setItem('dlinkcameras', JSON.stringify(dlinkcameras)); //save to local storage
			window.app.hideLoading();
		}
	}

	loginNVRFailed = () => {
		window.app.hideLoading();
		if (this.from == 'DLinkAddCamera') {
			window.app.showToast(this.props.receiver.getString('ipcam_deviceaddedfailed'), 3000);
		}
	}

	handleScanQrCode = () => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		window.QRScanner.prepare(this.onDone);
	}

	onDone = (err, status) => {
		// Tommy - 05/04/2021 - User selects "Allow"
		if (err == null) {
			// here we can handle errors and clean up any loose ends.
			if (status.authorized) {
				window.QRScanner.show();
				window.app.content_area.current.switch_content.current.showQRScanner();
				window.QRScanner.scan(this.displayContents);
			}
		} else {
			window.app.showToast(this.props.receiver.getString('permission_fail'), 3000);
		}

		// if (err) {
		// 	// here we can handle errors and clean up any loose ends.
		// 	console.error(err);
		// }
		// if (status.authorized) {
		// 	// W00t, you have camera access and the scanner is initialized.
		// 	window.QRScanner.show();
		// 	window.app.content_area.current.switch_content.current.showQRScanner();
		// 	window.QRScanner.scan(this.displayContents);
		// } else if (status.denied) {
		// 	// The video preview will remain black, and scanning is disabled. We can
		// 	// try to ask the user to change their mind, but we'll have to send them
		// 	// to their device settings with `QRScanner.openSettings()`.
		// } else {
		// 	// we didn't get permission, but we didn't get permanently denied. (On
		// 	// Android, a denial isn't permanent unless the user checks the "Don't
		// 	// ask again" box.) We can ask again at the next relevant opportunity.
		// }
	}

	displayContents = (err, text) => {
		if (err) {
			console.log(err);
		} else {
			this.setState({
				serialNo: text
			});
		}
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		window.app.content_area.current.switch_content.current.hideQRScanner();
	}

	//Delete device
	handleDeleteDevice = () => {
		window.app.hideLoading();
		let confirmPopUp = window.confirm(this.props.receiver.getString("conf_del"));
		if (confirmPopUp == true) {
			let dlinkcameras = JSON.parse(window.localStorage.getItem('dlinkcameras'));
			let cameras = dlinkcameras[this.controller_mac_addr][this.controller_username].cameras;
			cameras.splice(this.index, 1); //remove the element from the array
			dlinkcameras[this.controller_mac_addr][this.controller_username].cameras = cameras
			window.localStorage.setItem('dlinkcameras', JSON.stringify(dlinkcameras)); //save to local storage
			this.handlePrevious();
		}
	}

	render() {

		let is_landscape = this.props.width > this.props.height;

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			color: 'white',
			height: this.props.height,
			overflow: 'auto',
		}

		let container_style = {
			justifyContent: 'center',
			alignItems: 'center',
			paddingBottom: 60
		}

		let roundedLayout = {
			borderRadius: 10,
			background: '#f9f9f9',
			padding: 20,
			margin: 10,
		}

		let inputContainer = {
			backgroundColor: 'transparent',
			border: 'none',
			padding: 10,
			outline: 'none',
			textAlign: 'left',
			width: '100%'
		}

		let deviceInfoContainer = {
			marginLeft: 5,
			maxWidth: '80%',
			textAlign: 'left',
		}

		let deviceContainer = {
			backgroundColor: '#f9f9f9',
			borderRadius: 10,
			maxWidth: '100%',
			width: 'auto',
			alignItems: 'center',
			justifyContent: 'left',
			position: 'relative',
			display: 'flex',
			marginTop: 10,
			marginBottom: 10,
			padding: 10
		}

		let iconContainer = {
			padding: 10,
			maxWidth: '20%',
			marginLeft: 10,
		}

		let deviceName = {
			fontSize: 16,
			color: 'black',
			fontWeight: 'bold',
			padding: 0,
			margin: 5,
		}

		let serialNo = {
			fontSize: 14,
			color: '#BBBBBB',
			margin: 5,
			padding: 0
		}

		let cctvIcon_style = {
			width: 52,
			height: 52,
		}

		let nvrContainerStyle = {
			paddingLeft: 20,
			paddingRight: 20,
			overflowY: 'auto',
			height: this.props.height,
			maxHeight: 250,
		}

		return (
			<div>
				<div style={main_content_style} className='slideInDown noScrollBar'>

					<Top_Bar
						width={this.props.width}
						title={this.from == 'DLinkEditCamera' ? this.props.receiver.getString('edit_device') : this.props.receiver.getString('ipcam_addipcamera')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={this.from == 'DLinkEditCamera' ? 'delete' : null}
						handleRightButton={this.handleDeleteDevice}
					/>

					{/* Header */}
					{/* <div style={{ paddingTop: 20, paddingBottom: 20, alignItems: 'center', zIndex: 999 }}>
						<div style={{ width: 100, display: 'inline-block', textAlign: 'left' }} onClick={this.handlePrevious}>
							<img src={back} style={{ width: 20, height: 20, marginLeft: 30 }} />
						</div>
						<div style={{ width: this.props.width - 200, maxWidth: this.props.width - 200, textAlign: 'center', display: 'inline-block' }}>
							<span style={{ fontSize: 'large', color: 'black', fontWeight: 'bold' }}>{this.props.receiver.getString('dlink_add_device')}</span>
						</div>
						<div style={{ width: 100, display: 'inline-block', textAlign: 'right' }}>
							<img src={check} style={{ width: 20, height: 20, marginRight: 30, visibility:'hidden' }} />
						</div>
					</div> */}

					{/* Fields */}
					<div style={container_style}>

						{/* Username */}
						<div id='username_container' style={{ textAlign: 'center', marginLeft: 20, marginRight: 20, marginTop: 20 }}>
							<Editbox id='username' style={{ width: this.props.width - 40, color: 'black' }} placeholder={this.props.receiver.getString('usrname')} inputType='text' onChange={(event) => this.handleChangeUsername(event.target.value)} value={this.state.username} required />
						</div>

						{/* Password */}
						<div id='password_container' style={{ textAlign: 'center', marginLeft: 20, marginRight: 20, marginTop: 20 }}>
							<Editbox id='password' style={{ width: this.props.width - 40, color: 'black' }} placeholder={this.props.receiver.getString('passwd')} inputType='password' onChange={(event) => this.handleChangePassword(event.target.value)} value={this.state.password} required />
						</div>

						{/* Serial Number  */}
						<div id='serialnumber_container' style={{ width: '100%', display: 'flex', alignItems: 'center', marginTop: 20 }}>
							<div style={{ textAlign: 'left', marginLeft: 20, marginRight: this.from == 'DLinkEditCamera' ? 20 : 0, width: this.from == 'DLinkEditCamera' ? '100%' : is_landscape ? '90%' : '80%' }}>
								<Editbox id='serialNo' style={{ width: '100%', color: 'black' }} placeholder={this.props.receiver.getString('ipcam_enter_serialno')} inputType='text' onChange={(event) => this.from == 'DLinkEditCamera' ? null : this.handleChangeSerialNo(event.target.value)} value={this.state.serialNo} />
							</div>

							{/* QR Code */}
							{this.from == 'DLinkEditCamera' ? null : <div style={{ width: is_landscape ? '10%' : '20%', textAlign: 'center', paddingRight: '10px' }}>
								<img src={qrcode} style={{ width: '50%' }} onClick={this.handleScanQrCode} />
							</div>}
						</div>

						{/* Device Name */}
						<div style={{ textAlign: 'center', marginLeft: 20, marginRight: 20, marginTop: 20 }}>
							<Editbox id='deviceName' style={{ width: this.props.width - 40, color: 'black' }} placeholder={this.props.receiver.getString('ipcam_devicename')} inputType='text' maxLength="50" onChange={(event) => this.handleChangeDeviceName(event.target.value)} value={this.state.device_name} required />
						</div>

						{/* Device Type */}
						{this.from == 'DLinkEditCamera' ?
							<div style={{ textAlign: 'left', marginRight: 20 }}>
								<div style={{ marginTop: 20, marginLeft: 20, display: 'inline-block' }}>
									<span style={{ color: 'black', display: 'inline-block' }}>{this.props.receiver.getString("dlink_devicetype") + " : " + this.state.device_type}</span>
								</div>
							</div> : null}

						{/* <div style={{ width: '100%', display: 'flex', alignItems: 'center', marginTop:10 }}>
							<div style={{ borderRadius: 10, background: '#f9f9f9', padding: 20, marginLeft: 10, marginRight: 10, width: '80%' }}>
								<input style={inputContainer} id="serialNo" type="text" placeholder={this.props.receiver.getString("ipcam_enter_serialno")} value={this.state.serialNo} onChange={(event) => this.handleChangeSerialNo(event.target.value)} required />
							</div>
							<div style={{ width: '20%', textAlign: 'center', paddingRight: '10px' }} onClick={this.handleScanQrCode}>
								<img src={qrcode} style={{ width: '50%' }} />
							</div>
						</div> */}

						{/* Device Name */}
						{/* <div style={roundedLayout}>
							<input style={inputContainer} id="deviceName" type="text" maxLength="20" placeholder={this.props.receiver.getString("ipcam_devicename")} value={this.state.deviceName} onChange={(event) => this.handleChangeDeviceName(event.target.value)} required />
						</div> */}

						<div style={{ textAlign: 'center', color: '#6E6E6E', marginTop: 20 }}>
							<p>{this.props.receiver.getString("ipcam_makesuredeviceonline")}</p>
						</div>

						{/* Display list of cameras connected to the NVR */}
						{this.from == 'DLinkEditCamera' ?
							<div style={nvrContainerStyle}>
								<div id="deviceContainer">
									{this.state.temp_devices.map((device_info, index) => {
										return (
											<div style={deviceContainer} id={index}>
												<div style={iconContainer}>{
													<img style={cctvIcon_style} src={ipcam} />
												}
												</div>
												<div style={deviceInfoContainer}>
													<p style={deviceName}>{device_info.camera_name}</p>
													<p style={serialNo}>{this.props.receiver.getString("dlink_channelid") + " : "} {device_info.channel_id}</p>
												</div>
											</div>
										)
									})}
								</div>
							</div> : null}

					</div>
				</div>

			</div>
		)
	}
}